export default {
  login: {
    welcome: 'আবার স্বাগতম',
    subtitle: 'কেনাকাটা চালিয়ে যেতে লগ ইন করুন',
    phonePlaceholder: 'ফোন নম্বর লিখুন',
    passwordPlaceholder: 'পাসওয়ার্ড লিখুন',
    showPassword: 'দেখান',
    hidePassword: 'লুকান',
    loginButton: 'লগ ইন',
    registerButton: 'বিনামূল্যে নিবন্ধন',
    title: 'লগ ইন',
    subtitle2: 'পুরস্কার অর্জনের জন্য এক-স্টপ গ্লোবাল শপিং',
    logging: 'লগ ইন হচ্ছে...',
    phoneRequired: 'ফোন নম্বর লিখুন',
    passwordRequired: 'পাসওয়ার্ড লিখুন',
    loginSuccess: 'লগ ইন সফল',
    loginFailed: 'লগ ইন ব্যর্থ',
    loginError: 'লগ ইন ত্রুটি, পরে আবার চেষ্টা করুন'
  },
  register: {
    title: 'অ্যাকাউন্ট তৈরি করুন',
    subtitle: 'আমাদের সাথে যোগ দিন এবং আপনার ট্রেডিং যাত্রা শুরু করুন',
    username: 'ব্যবহারকারী নাম',
    phone: 'ফোন নম্বর',
    loginPassword: 'লগ ইন পাসওয়ার্ড',
    transactionPassword: 'লেনদেন পাসওয়ার্ড',
    invitationCode: 'আমন্ত্রণ কোড',
    usernamePlaceholder: 'ব্যবহারকারী নাম লিখুন',
    phonePlaceholder: 'ফোন নম্বর লিখুন',
    loginPasswordPlaceholder: 'লগ ইন পাসওয়ার্ড লিখুন',
    transactionPasswordPlaceholder: 'লেনদেন পাসওয়ার্ড লিখুন',
    invitationCodePlaceholder: 'আমন্ত্রণ কোড লিখুন',
    registerButton: 'নিবন্ধন করুন',
    hasAccount: 'ইতিমধ্যে অ্যাকাউন্ট আছে? লগ ইন',
    errorUsername: 'ব্যবহারকারী নাম লিখুন',
    errorPhone: 'ফোন নম্বর লিখুন',
    errorLoginPassword: 'লগ ইন পাসওয়ার্ড লিখুন',
    errorTransactionPassword: 'লেনদেন পাসওয়ার্ড লিখুন',
    errorInviteCode: 'আমন্ত্রণ কোড লিখুন',
    registerSuccess: 'নিবন্ধন সফল'
  },
  tabbar: {
    home: 'হোম',
    purchase: 'অর্ডার ইতিহাস',
    grabbing: 'অর্ডার',
    kefu: 'গ্রাহক সেবা',
    my: 'আমার'
  },
  home: {
    orderCount: 'অর্ডার সংখ্যা',
    upgradeAmount: 'রিচার্জ এবং আপগ্রেড',
    recharge: 'রিচার্জ',
    withdraw: 'উত্তোলন',
    team: 'টিম ব্যবস্থাপনা',
    commission: 'কমিশন পান',
    newProducts: 'নতুন পণ্য',
    newProductsDesc: 'নতুন সিজন এবং ভবিষ্যতের সংগ্রহের সর্বশেষ শৈলী।',
    buyNow: 'এখনই কিনুন',
    nowAvailable: 'এখন উপলব্ধ',
    nowAvailableDesc: 'বিয়ের মৌসুমের জন্য প্রস্তুত হন, আপনার পরবর্তী ভ্রমণের জন্য সামগ্রী প্যাক করুন এবং কোনো প্রতিশ্রুতি ছাড়াই আপনার ওয়ারডরোব আপডেট করুন। আমাদের নতুন লোন প্ল্যানের সাথে, আপনি সর্বশেষ প্রবণতাগুলি চেষ্টা করতে পারেন এবং সাবস্ক্রিপশন ছাড়াই আপনার বাজেটের মধ্যে থাকতে পারেন।',
    footerTitle: 'Desigual.com',
    footerFollow: "{'@'}Desigual.com-এ আমাদের অনুসরণ করুন এবং আপনার প্রিয় Desigual.com লুকগুলি শেয়ার করুন!",
    footerShop: 'আমাদের ক্যাটালগ ব্রাউজ করুন'
  },
  purchase: {
    all: 'সব',
    pending: 'মুলতুবি',
    completed: 'সম্পন্ন',
    frozen: 'জমে আছে',
    balance: 'অ্যাকাউন্ট ব্যালেন্স',
    orderTime: 'অর্ডার সময়',
    orderId: 'অর্ডার নম্বর',
    totalAmount: 'মোট পরিমাণ',
    commission: 'কমিশন',
    expectedReturn: 'প্রত্যাশিত ফেরত',
    submitOrder: 'অর্ডার জমা দিন',
    orderCompleted: 'অর্ডার সম্পন্ন',
    loading: 'লোড হচ্ছে...',
    noData: 'কোনো অর্ডার ডেটা নেই',
    noMore: 'আর নেই',
    orderSuccess: 'অর্ডার সফল',
    orderNumber: 'অর্ডার নম্বর',
    rating: 'রেটিং',
    notSubmit: 'এখন জমা দেবেন না',
    submitNow: 'এখন জমা দিন',
    submitting: 'জমা হচ্ছে...',
    submitFailed: 'জমা দিতে ব্যর্থ',
    grabOrderFailed: 'অর্ডার নিতে ব্যর্থ, পরে আবার চেষ্টা করুন',
    getOrderInfoFailed: 'অর্ডার বিবরণ পেতে ব্যর্থ',
    submitOrderFailed: 'জমা দিতে ব্যর্থ, পরে আবার চেষ্টা করুন'
  },
  common: {
    home: 'হোম',
    about: 'সম্পর্কে',
    contact: 'যোগাযোগ করুন',
    purchase: 'অর্ডার ইতিহাস',
    grabbing: 'অর্ডার',
    my: 'আমার',
    login: 'লগ ইন',
    register: 'নিবন্ধন',
    kefu: 'গ্রাহক সেবা',
    loadDataError: 'ডেটা লোড করতে ব্যর্থ, পরে আবার চেষ্টা করুন',
    success: 'অপারেশন সফল',
    failed: 'অপারেশন ব্যর্থ',
    submitSuccess: 'জমা সফল',
    submitFailed: 'জমা ব্যর্থ',
    submitting: 'জমা হচ্ছে...'
  },
  grabbing: {
    accountAmount: 'অ্যাকাউন্ট পরিমাণ',
    accountBalance: 'অ্যাকাউন্ট ব্যালেন্স',
    getCommission: 'কমিশন পান',
    ordersGrabbedToday: 'আজ নেওয়া অর্ডার',
    orderCount: 'অর্ডার সংখ্যা',
    operationSteps: 'অপারেশন ধাপ',
    step1: '1. কাজ শুরু করুন বোতামে ক্লিক করুন এবং নির্দেশনা অনুযায়ী কাজ সম্পন্ন করুন',
    step2: '2. কাজ সম্পন্ন হওয়ার পরে, আপনি কমিশন ব্যালেন্সে সেটেল করতে পারেন',
    grabOrder: 'অর্ডার নিন',
    pleaseWait: 'দয়া করে অপেক্ষা করুন',
    grabSuccess: 'অর্ডার সফল',
    grabTime: 'অর্ডার সময়',
    grabNumber: 'অর্ডার নম্বর',
    orderTotal: 'মোট পরিমাণ',
    commission: 'কমিশন',
    expectedReturn: 'প্রত্যাশিত ফেরত',
    rating: 'রেটিং',
    notSubmit: 'এখন জমা দেবেন না',
    submitNow: 'এখন জমা দিন',
    submitting: 'জমা হচ্ছে...'
  },
  kefu: {
    title: 'গ্রাহক সেবা',
    intro: {
      line1: 'আপনার কোনো প্রশ্ন বা সহায়তার প্রয়োজন হলে,',
      line2: 'সমাধানের জন্য গ্রাহক সেবার সাথে যোগাযোগ করুন'
    },
    serviceTime: {
      label: 'সেবা সময়',
      text: 'আপনার এক্সক্লুসিভ গ্রাহক সেবা',
      online: 'অনলাইন'
    },
    contact: {
      title: 'যোগাযোগ',
      name: 'অনলাইন',
      status: 'পরামর্শ',
      feature1: 'তাৎক্ষণিক উত্তর',
      feature2: 'পেশাদার সেবা',
      button: 'যোগাযোগ করুন'
    },
    faq: {
      title: 'সাধারণ প্রশ্নাবলী',
      rechargeQuestion: 'কিভাবে রিচার্জ করব?',
      rechargeAnswer: 'আপনি আমাদের নিরাপদ পেমেন্ট গেটওয়ের মাধ্যমে রিচার্জ করতে পারেন। আমার অ্যাকাউন্ট > রিচার্জ এ যান এবং নির্দেশনা অনুসরণ করুন।',
      withdrawQuestion: 'কিভাবে উত্তোলন করব?',
      withdrawAnswer: 'উত্তোলন আমার অ্যাকাউন্ট > উত্তোলন এর মাধ্যমে করা যায়। নিশ্চিত করুন যে আপনার অ্যাকাউন্ট যাচাই করা আছে।',
      minRechargeQuestion: 'ন্যূনতম রিচার্জ পরিমাণ কত?',
      minRechargeAnswer: 'ন্যূনতম রিচার্জ পরিমাণ ${currency}68।',
      withdrawTimeQuestion: 'উত্তোলনে কত সময় লাগে?',
      withdrawTimeAnswer: 'উত্তোলন সাধারণত 24 ঘন্টার মধ্যে প্রক্রিয়া করা হয়।',
      securityQuestion: 'আমার তথ্য কি নিরাপদ?',
      securityAnswer: 'হ্যাঁ, আমরা আপনার ব্যক্তিগত এবং আর্থিক তথ্য রক্ষা করতে শিল্প মানের এনক্রিপশন প্রযুক্তি ব্যবহার করি।'
    }
  },
  my: {
    inviteCode: 'আমন্ত্রণ কোড',
    copy: 'কপি',
    copySuccess: 'কপি সফল',
    copyFailed: 'কপি ব্যর্থ',
    online: 'অনলাইন',
    accountAmount: 'অ্যাকাউন্ট পরিমাণ',
    balance: 'অ্যাকাউন্ট ব্যালেন্স',
    accountBalanceTrend: 'অ্যাকাউন্ট ব্যালেন্স',
    todayCommission: 'আজকের কমিশন',
    totalCommission: 'মোট কমিশন',
    today: 'আজ',
    total: 'মোট',
    todayOrders: 'আজ নেওয়া অর্ডার',
    orderCount: 'অর্ডার সংখ্যা',
    recharge: 'রিচার্জ',
    withdraw: 'উত্তোলন',
    rechargeRecord: 'রিচার্জ ইতিহাস',
    withdrawRecord: 'উত্তোলন ইতিহাস',
    accountDetails: 'অ্যাকাউন্ট বিবরণ',
    receivingAccount: 'গ্রহণ অ্যাকাউন্ট',
    bankAccount: 'ব্যাংক অ্যাকাউন্ট',
    bankAccountDesc: 'ব্যাংক অ্যাকাউন্ট',
    usdt: 'USDT',
    usdtDesc: 'USDT ঠিকানা',
    connect: 'সংযোগ',
    teamManagement: 'টিম ব্যবস্থাপনা',
    viewTeam: 'টিম দেখুন',
    changePassword: 'পাসওয়ার্ড পরিবর্তন',
    changeWithdrawPassword: 'উত্তোলন পাসওয়ার্ড পরিবর্তন',
    passwordSettings: 'পাসওয়ার্ড সেটিংস',
    logout: 'লগ আউট',
    signOut: 'লগ আউট',
    version: 'সংস্করণ'
  },
  changePasswordPage: {
    currentPassword: 'বর্তমান লগ ইন পাসওয়ার্ড',
    currentPasswordPlaceholder: 'বর্তমান পাসওয়ার্ড লিখুন',
    newPassword: 'নতুন লগ ইন পাসওয়ার্ড',
    newPasswordPlaceholder: 'নতুন পাসওয়ার্ড লিখুন',
    confirmPassword: 'লগ ইন পাসওয়ার্ড নিশ্চিত করুন',
    confirmPasswordPlaceholder: 'নতুন পাসওয়ার্ড নিশ্চিত করুন',
    notice: 'লগ ইন পাসওয়ার্ড অ্যাকাউন্ট অ্যাক্সেস করতে ব্যবহৃত হয়। নিরাপত্তা নিশ্চিত করতে পাসওয়ার্ডে কমপক্ষে 6 অক্ষর থাকতে হবে এবং এতে অক্ষর এবং সংখ্যা অন্তর্ভুক্ত থাকতে হবে।',
    updateButton: 'লগ ইন পাসওয়ার্ড আপডেট করুন',
    errorOldPassword: 'বর্তমান পাসওয়ার্ড লিখুন',
    errorNewPassword: 'নতুন পাসওয়ার্ড লিখুন',
    errorConfirmPassword: 'নতুন পাসওয়ার্ড নিশ্চিত করুন',
    errorPasswordMismatch: 'পাসওয়ার্ড মিলছে না',
    errorPasswordLength: 'পাসওয়ার্ডে কমপক্ষে 6 অক্ষর থাকতে হবে',
    errorPasswordFormat: 'পাসওয়ার্ডে অক্ষর এবং সংখ্যা অন্তর্ভুক্ত থাকতে হবে'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'বর্তমান উত্তোলন পাসওয়ার্ড',
    currentPasswordPlaceholder: 'বর্তমান উত্তোলন পাসওয়ার্ড লিখুন',
    newPassword: 'নতুন উত্তোলন পাসওয়ার্ড',
    newPasswordPlaceholder: 'নতুন উত্তোলন পাসওয়ার্ড লিখুন',
    confirmPassword: 'উত্তোলন পাসওয়ার্ড নিশ্চিত করুন',
    confirmPasswordPlaceholder: 'নতুন উত্তোলন পাসওয়ার্ড নিশ্চিত করুন',
    notice: 'উত্তোলন পাসওয়ার্ড তহবিল উত্তোলন অপারেশনের জন্য ব্যবহৃত হয়। নিরাপত্তা নিশ্চিত করতে পাসওয়ার্ডে কমপক্ষে 6 অক্ষর থাকতে হবে এবং এতে অক্ষর এবং সংখ্যা অন্তর্ভুক্ত থাকতে হবে।',
    updateButton: 'উত্তোলন পাসওয়ার্ড আপডেট করুন',
    errorOldPassword: 'বর্তমান উত্তোলন পাসওয়ার্ড লিখুন',
    errorNewPassword: 'নতুন উত্তোলন পাসওয়ার্ড লিখুন',
    errorConfirmPassword: 'নতুন উত্তোলন পাসওয়ার্ড নিশ্চিত করুন',
    errorPasswordMismatch: 'পাসওয়ার্ড মিলছে না',
    errorPasswordLength: 'পাসওয়ার্ডে কমপক্ষে 6 অক্ষর থাকতে হবে',
    errorPasswordFormat: 'পাসওয়ার্ডে অক্ষর এবং সংখ্যা অন্তর্ভুক্ত থাকতে হবে'
  },
  details: {
    loading: 'লোড হচ্ছে...',
    noRecords: 'কোনো রেকর্ড নেই',
    noMore: 'আর নেই',
    time: 'সময়',
    type: 'ধরন',
    amount: 'পরিমাণ',
    balance: 'ব্যালেন্স',
    remark: 'মন্তব্য',
    type0: 'অন্যান্য',
    type1: 'রিচার্জ',
    type2: 'উত্তোলন',
    type3: 'লেনদেন',
    type4: 'অর্ডার কমিশন',
    type5: 'অধীন কমিশন',
    type8: 'উত্তোলন প্রত্যাখ্যাত'
  },
  rechargeRecord: {
    offline: 'অফলাইন রিচার্জ',
    online: 'অনলাইন রিচার্জ',
    loading: 'লোড হচ্ছে...',
    noRecords: 'কোনো রেকর্ড নেই',
    orderNo: 'অর্ডার নম্বর',
    rechargeAmount: 'রিচার্জ পরিমাণ',
    rechargeTime: 'রিচার্জ সময়',
    payMethod: 'পেমেন্ট পদ্ধতি',
    rechargeStatus: 'রিচার্জ স্থিতি',
    noMore: 'আর নেই',
    statusPending: 'অনুমোদনের জন্য অপেক্ষমান',
    statusApproved: 'অনুমোদিত',
    statusFailed: 'ব্যর্থ',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'লোড হচ্ছে...',
    noRecords: 'কোনো রেকর্ড নেই',
    orderNo: 'অর্ডার নম্বর',
    withdrawAmount: 'উত্তোলন পরিমাণ',
    withdrawTime: 'উত্তোলন সময়',
    withdrawAddress: 'উত্তোলন ঠিকানা',
    withdrawStatus: 'উত্তোলন স্থিতি',
    noMore: 'আর নেই',
    statusPending: 'প্রক্রিয়াধীন',
    statusApproved: 'সফল',
    statusFailed: 'ব্যর্থ',
    statusEmpty: ''
  },
  withdraw: {
    title: 'উত্তোলন',
    method: 'উত্তোলন পদ্ধতি',
    methodSubtitle: 'আপনার উত্তোলন পদ্ধতি নির্বাচন করুন',
    bankInfo: 'ব্যাংক অ্যাকাউন্ট তথ্য',
    bankName: 'ব্যাংক',
    accountHolder: 'অ্যাকাউন্ট ধারকের নাম',
    bankCard: 'ব্যাংক কার্ড',
    amount: 'উত্তোলন পরিমাণ',
    balance: 'ব্যালেন্স',
    withdrawAll: 'সব উত্তোলন করুন',
    paymentPassword: 'পেমেন্ট পাসওয়ার্ড',
    passwordPlaceholder: 'তহবিল পাসওয়ার্ড লিখুন',
    principal: 'মূল পরিমাণ',
    serviceFee: 'সেবা ফি',
    netAmount: 'নিট পরিমাণ',
    notice: '*গ্রহণ তথ্য সাবধানে যাচাই করুন',
    withdrawButton: 'উত্তোলন',
    walletAddress: 'ওয়ালেট ঠিকানা',
    walletAddressSubtitle: 'ওয়ালেট ঠিকানা লিখুন'
  },
  recharge: {
    title: 'রিচার্জ',
    amount: 'রিচার্জ পরিমাণ',
    amountSubtitle: 'আপনি রিচার্জ করতে চান এমন পরিমাণ লিখুন',
    quickSelect: 'দ্রুত নির্বাচন',
    rechargeNow: 'এখন রিচার্জ করুন',
    selectPayment: 'পেমেন্ট পদ্ধতি নির্বাচন করুন',
    selectPaymentSubtitle: 'আপনার পছন্দের পেমেন্ট পদ্ধতি নির্বাচন করুন',
    cancel: 'বাতিল',
    confirm: 'নিশ্চিত',
    crypto: 'ক্রিপ্টোকারেন্সি',
    bank: 'ব্যাংক ট্রান্সফার',
    paymentRange: 'ন্যূনতম: {symbol}{minAmount} - সর্বোচ্চ: {symbol}{maxAmount}',
    rechargeFailed: 'রিচার্জ ব্যর্থ',
    paymentInfo: 'পেমেন্ট তথ্য',
    usercode: 'USDT ঠিকানা',
    uploadScreenshot: 'দয়া করে পেমেন্ট স্ক্রিনশট আপলোড করুন',
    clickToUpload: 'স্ক্রিনশট আপলোড করতে ক্লিক করুন',
    copySuccess: 'সফলভাবে কপি করা হয়েছে',
    copyFailed: 'কপি করতে ব্যর্থ',
    uploadScreenshotRequired: 'দয়া করে পেমেন্ট স্ক্রিনশট আপলোড করুন',
    submit: 'জমা দিন',
    submitting: 'জমা দিচ্ছি...',
    submitSuccess: 'সফলভাবে জমা দেওয়া হয়েছে',
    submitFailed: 'জমা দিতে ব্যর্থ'
  },
  bindUsdt: {
    title: 'USDT বাইন্ড করুন',
    cardTitle: 'USDT ঠিকানা',
    cardSubtitle: 'আপনার USDT ওয়ালেট ঠিকানা লিখুন',
    walletAddress: 'ওয়ালেট ঠিকানা',
    walletAddressPlaceholder: 'USDT ওয়ালেট ঠিকানা লিখুন',
    networkType: 'নেটওয়ার্ক ধরন',
    networkTypePlaceholder: 'নেটওয়ার্ক ধরন নির্বাচন করুন',
    withdrawPassword: 'উত্তোলন পাসওয়ার্ড',
    withdrawPasswordPlaceholder: 'উত্তোলন পাসওয়ার্ড লিখুন',
    trc20: 'TRC20',
    trc20Network: 'TRC20 নেটওয়ার্ক',
    erc20: 'ERC20',
    erc20Network: 'ERC20 নেটওয়ার্ক',
    securityNotice: 'নিরাপত্তা নোটিশ',
    securityText1: '• আপনার USDT ঠিকানা এনক্রিপ্ট করা এবং নিরাপদভাবে সংরক্ষিত',
    securityText2: '• শুধুমাত্র আপনি এই তথ্য দেখতে এবং পরিবর্তন করতে পারেন',
    securityText3: '• সমস্ত তথ্য সঠিক তা নিশ্চিত করুন',
    buttonText: 'তথ্য সংরক্ষণ করুন',
    buttonSubtitle: 'USDT ঠিকানা বাইন্ড করুন',
    errorWalletAddress: 'ওয়ালেট ঠিকানা লিখুন',
    errorNetworkType: 'নেটওয়ার্ক ধরন নির্বাচন করুন',
    errorWithdrawPassword: 'উত্তোলন পাসওয়ার্ড লিখুন'
  },
  team: {
    title: 'টিম ব্যবস্থাপনা',
    level1: 'স্তর 1 টিম',
    level2: 'স্তর 2 টিম',
    level3: 'স্তর 3 টিম',
    level1Members: 'স্তর 1 টিম সদস্য',
    level2Members: 'স্তর 2 টিম সদস্য',
    level3Members: 'স্তর 3 টিম সদস্য',
    totalMembers: 'মোট সদস্য',
    totalCommission: 'মোট কমিশন',
    members: 'জন',
    orders: 'অর্ডার',
    commission: 'কমিশন',
    noMembers: 'কোনো সদস্য নেই',
    loading: 'লোড হচ্ছে...',
    noMore: 'আর নেই'
  },
  bindBank: {
    title: 'ব্যাংক কার্ড বাইন্ড করুন',
    cardTitle: 'ব্যাংক তথ্য',
    cardSubtitle: 'আপনার ব্যাংক নির্বাচন করুন এবং অ্যাকাউন্ট বিবরণ লিখুন',
    bankName: 'ব্যাংক',
    bankNamePlaceholder: 'ব্যাংকের নাম লিখুন',
    cardNumber: 'কার্ড নম্বর',
    cardNumberPlaceholder: 'কার্ড নম্বর লিখুন',
    realName: 'আসল নাম',
    realNamePlaceholder: 'আসল নাম লিখুন',
    withdrawPassword: 'উত্তোলন পাসওয়ার্ড',
    withdrawPasswordPlaceholder: 'উত্তোলন পাসওয়ার্ড লিখুন',
    securityNotice: 'নিরাপত্তা নোটিশ',
    securityText1: '• আপনার ব্যাংক তথ্য এনক্রিপ্ট করা এবং নিরাপদভাবে সংরক্ষিত',
    securityText2: '• শুধুমাত্র আপনি এই তথ্য দেখতে এবং পরিবর্তন করতে পারেন',
    securityText3: '• সমস্ত তথ্য সঠিক তা নিশ্চিত করুন',
    buttonText: 'তথ্য সংরক্ষণ করুন',
    buttonSubtitle: 'ব্যাংক অ্যাকাউন্ট বাইন্ড করুন',
    errorBankName: 'ব্যাংকের নাম লিখুন',
    errorCardNumber: 'কার্ড নম্বর লিখুন',
    errorRealName: 'আসল নাম লিখুন',
    errorWithdrawPassword: 'উত্তোলন পাসওয়ার্ড লিখুন'
  }
}
